import {AREA_CHANGED, OPER_DATE_CHANGED, SWITCH_LANGUAGE} from "../../constants/ActionTypes";
import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL, LIGHT_BLUE,
  NAV_STYLE,
  NAV_STYLE_FIXED,
  THEME_COLOR,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK,
  UPDATE_RTL_STATUS,
} from "../../constants/ThemeSetting";
import getLocale from "../../util/getLocale";

const storedLanguage = localStorage.getItem("dmcsDefaultLanguage");
const defaultLanguage = window.appConfig.defaultLanguage;
let loadLanguage = storedLanguage ? storedLanguage : defaultLanguage;
const locale = getLocale(loadLanguage);

const storedThemeType = localStorage.getItem("dmcsThemeType");

const initialSettings = {
  navStyle: NAV_STYLE_FIXED,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: storedThemeType || THEME_TYPE_SEMI_DARK,
  themeColor: LIGHT_BLUE,

  isDirectionRTL: false,

  operDateIso: OPER_DATE_CHANGED,
  areaId: AREA_CHANGED,
  locale,
};

const SettingsReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType,
      };
    case THEME_COLOR:
      return {
        ...state,
        themeColor: action.themeColor,
      };

    case UPDATE_RTL_STATUS:
      return {
        ...state,
        isDirectionRTL: action.rtlStatus,
      };

    case NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle,
      };
    case LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType,
      };

    case SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.payload,
      };

    case OPER_DATE_CHANGED:
      return {
        ...state,
        operDateIso: action.operDateIso,
      };

    case AREA_CHANGED:
      return {
        ...state,
        areaId: action.areaId,
      };

    default:
      return state;
  }
};

export default SettingsReducer;
